module.exports = __webpack_public_path__ + "img/9.5f143166.svg";